import * as React from 'react';
import PulsoidClient from '../../PulsoidClient';
import {Redirect} from 'react-router';
import {Loader} from '../../system/Loader/Loader';
import {DASHBOARD_ROUTES} from '../navigation/dashboard/DashboardRoutes';
import {buildRoute} from '../navigation/navigationUtils';
import {generateRandomName} from '../../utils/generateRandomName';

export default class AddWidget extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      initing: true,
    };
  }

  componentDidMount() {
    new PulsoidClient()
      .addWidget(
        this.props.match.params.predefinedWidgetId ===
          '9e3c6afc-9f6c-43bb-b448-1a8a2accf5a8'
          ? '3f0cfd58-08e1-4fb3-8d39-fdbc8bc26429'
          : this.props.match.params.predefinedWidgetId,
        generateRandomName()
      )
      .then((res) => {
        this.setState({initing: false, widgetId: res.id});
      });
  }

  render() {
    if (this.state.initing) {
      return <Loader loading={true} description={'Initializing new widget'} />;
    }

    return (
      <Redirect
        to={{
          pathname: buildRoute({
            path: DASHBOARD_ROUTES.CONFIGURATION_EDIT_WIDGET,
            params: {id: this.state.widgetId},
          }),
        }}
      />
    );
  }
}
